import { getCities } from '../../api/authApi'
import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import { setActiveCitiesAction } from '../../store/city/action'
import { Card, Space } from 'antd'
import { useEffect } from 'react'
import { ConnectedProps, connect } from 'react-redux'
import { Outlet } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { compose } from 'redux'

const PrelaunchOrganizationFormsContainer = (props: ConnectedProps<typeof withConnect>) => {
  const location = useLocation()

  useEffect(() => {
    getCities().then(res => {
      const { setActiveCitiesAction } = props
      setActiveCitiesAction(res)
    })
  }, [])

  const getNavBarTitle = () => {
    const pathName = location.pathname

    if (pathName.match(/^\/prelaunch-organization-forms\/[0-9]+\/studios\/[0-9]+\/edit/)) {
      return translate('navBar.editPrelaunchStudios')
    }

    if (pathName.match(/^\/prelaunch-organization-forms\/[0-9]+\/studios\/[0-9]+/)) {
      return translate('navBar.viewPrelaunchStudios')
    }

    if (
      pathName.match(/^\/prelaunch-organization-forms\/[0-9]+\/lesson-descriptions\/[0-9]+\/edit/)
    ) {
      return translate('navBar.editPrelaunchLessonDescriptions')
    }

    if (pathName.match(/^\/prelaunch-organization-forms\/[0-9]+\/lesson-descriptions\/[0-9]+/)) {
      return translate('navBar.viewPrelaunchLessonDescriptions')
    }

    if (
      pathName.match(
        /^\/prelaunch-organization-forms\/[0-9]+\/company-payment-details\/[0-9]+\/edit/,
      )
    ) {
      return translate('navBar.editPrelaunchCompanyPaymentDetail')
    }

    if (pathName.match(/^\/prelaunch-organization-forms\/[0-9]+$/)) {
      return translate('navBar.viewPrelaunchOrganizationForms')
    }

    return translate('navBar.prelaunchOrganizationFormsTitle')
  }

  return (
    <Space className="dashboard-wrapper" orientation="vertical">
      <NavBar title={getNavBarTitle()}></NavBar>
      <Card>
        <Outlet />
      </Card>
    </Space>
  )
}

const mapDispatchToProps = {
  setActiveCitiesAction,
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(withConnect)(PrelaunchOrganizationFormsContainer)
